import type { Consent } from './consent';

// GA4 property used for product analytics
const GA4_ANALYTICS = 'G-0BGG5V2W2K';
// GA4 property linked to Google Ads
const GA4_ADS = 'G-13FXVW9L6R';
// GTM container with no ad tracking pixels
const AD_FREE_GTM = 'GTM-M964NS9';

export interface TrackingScripts {
  gtmContainerId?: string;
  ga4Ids: string[];
}

/**
 * Which third party tracking scripts to load. Logged in users agreed to our
 * terms, so they get everything; logged out visitors get only what they
 * consented to in OneTrust. Sandbox keeps the ad-free container even when
 * logged out.
 */
export const getTrackingScripts = (
  isLoggedIn: boolean,
  { performance, targeting }: Consent,
  isSandbox = false,
): TrackingScripts => {
  if (isLoggedIn) {
    return {
      gtmContainerId: AD_FREE_GTM,
      ga4Ids: [GA4_ANALYTICS, GA4_ADS],
    };
  }
  return {
    // GTM-KS9CMZW contains ad conversion pixels, each gated on consent in the
    // GTM admin
    gtmContainerId: performance
      ? isSandbox
        ? AD_FREE_GTM
        : 'GTM-KS9CMZW'
      : undefined,
    // Counsel puts GA4 under Targeting (Google Signals is on), and OneTrust
    // lists its `_ga` cookies there too
    ga4Ids: targeting ? [GA4_ANALYTICS, GA4_ADS] : [],
  };
};
